import React from "react";
import { LoadingIndicator } from "@jsq/ds/core";
import { useConsolidatedPaymentPrefContext } from "../../../Context";
import { usePaginatedPositionsHook } from "../../SelectPositionsToUpdate/hooks";
import { PositionListToUpdateComponentWrapper } from "../PositionListToUpdateComponentWrapper";

export const UpdatePositionsWithPaymentPrefPositionList = () => {
  const { sourcePaymentPrefId, currentPosition, selectedPaymentMethod } =
    useConsolidatedPaymentPrefContext();
  const currentAccountId = currentPosition?.accountId;

  const { data, loading, fetchMoreHandler } = usePaginatedPositionsHook({
    accountId: currentAccountId ?? "",
    paymentPrefId: sourcePaymentPrefId,
    supportedPaymentMethod: selectedPaymentMethod,
    skip: !currentAccountId || !sourcePaymentPrefId,
  });

  if (loading) {
    return <LoadingIndicator />;
  }

  if (data?.account?.positions?.edges && data.account?.positions?.edges.length > 0) {
    return (
      <PositionListToUpdateComponentWrapper data={data} fetchMorePositions={fetchMoreHandler} />
    );
  }
  return null;
};
